import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    IconButton,
    Badge,
    Tabs,
    Tab,
    Button,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useUser } from "../contexts/UserContext";

interface HeaderProps {
    activeTab: string;
    onTabChange: (tab: string) => void;
    onLogout: () => void;
}

const PRIMARY_COLOR = "#003595";

export default function Header({ activeTab, onTabChange, onLogout }: HeaderProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const { userInfo } = useUser();
    
    const displayName = userInfo?.name || userInfo?.preferred_username || userInfo?.email || 'User';

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        onTabChange(newValue);
        
        // Navigate to the appropriate route
        if (newValue === "dashboard") {
            navigate("/");
        } else if (newValue === "patients") {
            navigate("/patients");
        }
    };

    return (
        <AppBar
            position="static"
            elevation={0}
            sx={{
                bgcolor: "#fff",
                borderBottom: "1px solid #e0e0e0",
            }}
        >
            <Toolbar
                sx={{
                    justifyContent: "space-between",
                    px: { xs: 2, md: 4 },
                    py: 1,
                }}
            >
                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        color: "#333",
                        fontWeight: 500,
                        letterSpacing: 3,
                        fontSize: "1.2rem",
                    }}
                >
                    MARLO
                </Typography>
                <Box>
                    {/* <IconButton
                        color="inherit"
                        sx={{
                            color: "#666",
                            marginRight: 2
                        }}
                    >
                        <Badge badgeContent={1} color="error">
                            <NotificationsIcon />
                        </Badge>
                    </IconButton> */}
                    <Typography variant="body1" component="span" sx={{ marginRight: 2, color: "#666" }}>
                        Welcome, {displayName}! {userInfo?.sub && (
                            <Box component="span" sx={{ fontWeight: 'bold', color: '#333' }}>
                                ({userInfo.sub})
                            </Box>
                        )}
                    </Typography>
                    <Button color="error" variant="contained" onClick={onLogout}>Logout</Button>
                </Box>
            </Toolbar>
            
            <Box sx={{ borderBottom: 1, borderColor: "divider", px: { xs: 2, md: 4 } }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "uppercase",
                            fontWeight: 500,
                            fontSize: "0.9rem",
                            letterSpacing: 1,
                            color: "#999",
                            minHeight: 48,
                        },
                        "& .Mui-selected": {
                            color: `${PRIMARY_COLOR} !important`,
                        },
                        "& .MuiTabs-indicator": {
                            backgroundColor: PRIMARY_COLOR,
                            height: 3,
                        },
                    }}
                >
                    <Tab label="Dashboard" value="dashboard" />
                    <Tab label="Patients" value="patients" />
                    {/* <Tab label="Account" value="account" /> */}
                </Tabs>
            </Box>
        </AppBar>
    );
}